export default {
    result: {
        sc_o: 'navigation_search_incremental_result_click',
    },
    query_result: {
        sc_o: 'navigation_search_suggestion_click',
    },
    all_results_fallback: {
        sc_o: 'navigation_search_incremental_fallback_click',
    },
    advanced_search: {
        sc_o: 'navigation_search_advanced_click',
    },
    all_results: {
        sc_o: 'navigation_search_incremental_all-results_click',
    },
};
//# sourceMappingURL=search-results.js.map